import { Component, OnInit, ViewEncapsulation } from "@angular/core";

@Component({
    selector: 'app-contact',
    template: require('./contact.component.pug')
})

export class ContactComponent implements OnInit {

    constructor(

    ){}

    ngOnInit():void {
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/route/public/contact/contact.component.ts